import AnalyseIcon from '@/shared/assets/icons/directory-modules/analyse.svg';
import AssessmentIcon from '@/shared/assets/icons/directory-modules/assessment.svg';
import BonusAltIcon from '@/shared/assets/icons/directory-modules/bonus-alt.svg';
import BoxArchiveIcon from '@/shared/assets/icons/directory-modules/box-archive.svg';
import BoxOpenFullIcon from '@/shared/assets/icons/directory-modules/box-open-full.svg';
import CameraCctvIcon from '@/shared/assets/icons/directory-modules/camera-cctv.svg';
import ChartHistogramIcon from '@/shared/assets/icons/directory-modules/chart-histogram.svg';
import CheckMarkCircleIcon from '@/shared/assets/icons/directory-modules/check-mark-circle.svg';
import Close2Icon from '@/shared/assets/icons/directory-modules/close-2.svg';
import DeskIcon from '@/shared/assets/icons/directory-modules/desk.svg';
import Error6Icon from '@/shared/assets/icons/directory-modules/error-6.svg';
import FingerprintVerifiedIcon from '@/shared/assets/icons/directory-modules/fingerprint-verified.svg';
import HandshakeIcon from '@/shared/assets/icons/directory-modules/handshake.svg';
import InboxFullIcon from '@/shared/assets/icons/directory-modules/inbox-full.svg';
import IndustryAltIcon from '@/shared/assets/icons/directory-modules/industry-alt.svg';
import ItIcon from '@/shared/assets/icons/directory-modules/it.svg';
import LocationAltIcon from '@/shared/assets/icons/directory-modules/location-alt.svg';
import NotoryIcon from '@/shared/assets/icons/directory-modules/notory.svg';
import OnboardingIcon from '@/shared/assets/icons/directory-modules/onboarding.svg';
import PracticeIcon from '@/shared/assets/icons/directory-modules/practice.svg';
import PulseIcon from '@/shared/assets/icons/directory-modules/pulse.svg';
import RecycleBinIcon from '@/shared/assets/icons/directory-modules/recycle-bin.svg';
import ReplaceIcon from '@/shared/assets/icons/directory-modules/replace.svg';
import SearchIcon from '@/shared/assets/icons/directory-modules/search.svg';
import ToolsIcon from '@/shared/assets/icons/directory-modules/tools.svg';
import TruckLoadingIcon from '@/shared/assets/icons/directory-modules/truck-loading.svg';
import UserHeadsetIcon from '@/shared/assets/icons/directory-modules/user-headset.svg';
import UserHelmetSafetyIcon from '@/shared/assets/icons/directory-modules/user-helmet-safety.svg';

/**
 * Ícones dos módulos no vocabulário do design system, com os mesmos ids que
 * `MODULES_DATA` grava em `Module.iconId` na seed do backend.
 */
export const DIRECTORY_MODULE_DESIGN_ICONS = [
  { id: 'analyse', icon: AnalyseIcon },
  { id: 'assessment', icon: AssessmentIcon },
  { id: 'bonus-alt', icon: BonusAltIcon },
  { id: 'box-archive', icon: BoxArchiveIcon },
  { id: 'box-open-full', icon: BoxOpenFullIcon },
  { id: 'camera-cctv', icon: CameraCctvIcon },
  { id: 'chart-histogram', icon: ChartHistogramIcon },
  { id: 'check-mark-circle', icon: CheckMarkCircleIcon },
  { id: 'close-2', icon: Close2Icon },
  { id: 'desk', icon: DeskIcon },
  { id: 'error-6', icon: Error6Icon },
  { id: 'fingerprint-verified', icon: FingerprintVerifiedIcon },
  { id: 'handshake', icon: HandshakeIcon },
  { id: 'inbox-full', icon: InboxFullIcon },
  { id: 'industry-alt', icon: IndustryAltIcon },
  { id: 'it', icon: ItIcon },
  { id: 'location-alt', icon: LocationAltIcon },
  { id: 'notory', icon: NotoryIcon },
  { id: 'onboarding', icon: OnboardingIcon },
  { id: 'practice', icon: PracticeIcon },
  { id: 'pulse', icon: PulseIcon },
  { id: 'recycle-bin', icon: RecycleBinIcon },
  { id: 'replace', icon: ReplaceIcon },
  { id: 'search', icon: SearchIcon },
  { id: 'tools', icon: ToolsIcon },
  { id: 'truck-loading', icon: TruckLoadingIcon },
  { id: 'user-headset', icon: UserHeadsetIcon },
  { id: 'user-helmet-safety', icon: UserHelmetSafetyIcon },
] as const;

export const DIRECTORY_MODULE_DESIGN_ICON_LABELS = {
  'analyse': 'Análise',
  'assessment': 'Avaliação',
  'bonus-alt': 'Bonificação',
  'box-archive': 'Caixa de arquivo',
  'box-open-full': 'Caixa aberta',
  'camera-cctv': 'Câmera de segurança',
  'chart-histogram': 'Gráfico de barras',
  'check-mark-circle': 'Confirmado',
  'close-2': 'Cancelado',
  'desk': 'Estação de trabalho',
  'error-6': 'Alerta',
  'fingerprint-verified': 'Biometria verificada',
  'handshake': 'Aperto de mãos',
  'inbox-full': 'Caixa de entrada',
  'industry-alt': 'Indústria',
  'it': 'TI',
  'location-alt': 'Localização',
  'notory': 'Documento oficial',
  'onboarding': 'Integração',
  'practice': 'Prática',
  'pulse': 'Monitoramento',
  'recycle-bin': 'Reciclagem',
  'replace': 'Substituição',
  'search': 'Busca',
  'tools': 'Ferramentas',
  'truck-loading': 'Carregamento',
  'user-headset': 'Atendimento',
  'user-helmet-safety': 'Segurança do trabalho',
} as const satisfies Record<
  (typeof DIRECTORY_MODULE_DESIGN_ICONS)[number]['id'],
  string
>;
